import React, {useEffect, useState} from "react";
import axios from "axios";
import { Row, Col, Input, Table, Divider, message, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import ENVIRONMENT from "../../../../environments";
import DottedLoader from "../../DottedLoader";
import SuccessModal from "../../SuccessModal/SuccessModal";

const AccountDetails = () => {
    const [allUsers, setAllUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [companies, setCompanies] = useState([]);
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        fetchAssignedCompanies();
    }, [])

    useEffect(() => {
        if(companies.length > 0) {
        axios.post(ENVIRONMENT.CUSTOMER_GET_BATCH, {})
        .then((res) => {
            const filteredUsers = res.data.filter(user => 
                user.company_id && 
                user.company_id.trim() !== '' && 
                user.subscription_package == 'Free Trial' &&
                !companies.some(company => company.company_id === user.company_id)
            );
            console.log(filteredUsers);
            setAllUsers(filteredUsers);
            setFilteredUsers(filteredUsers);
            setIsLoading(false);
        })
        .catch((err) => {
            console.log(err);
            setIsLoading(false);
        })
        }
    }, [companies])

    const fetchAssignedCompanies = async () => {
        try {
          const payload = { designer_username: localStorage.getItem('username') };
          const response = await axios.post(ENVIRONMENT.GET_MANAGED_SERVICE_RELATION, payload);
          const data = response.data;
  
          const uniqueCompaniesMap = new Map();
          data.forEach(entry => {
            if (!uniqueCompaniesMap.has(entry.company_id)) {
              uniqueCompaniesMap.set(entry.company_id, entry.company_name);
            }
          });
  
          const uniqueCompanies = Array.from(uniqueCompaniesMap, ([id, name]) => ({
            company_id: id,
            company_name: name,
          }));
          setCompanies(uniqueCompanies);
        } catch (error) {
          console.error('Error fetching company data:', error);
        } 
      };
 
    const assignUser = (record) => {
        console.log("*********", record);
        
        // Show loading message
        const loadingMessage = message.loading('Assigning User to your account', 0);
        
        // Find all users with the same company_id as the record
        const usersWithSameCompany = allUsers.filter(user => 
            user.company_id === record.company_id
        );
        
        const userList = usersWithSameCompany.map(user => ({
            company_id: user.company_id,
            customer_username: user.customer_username
        }));
        
        
        const payload = {
            designer_username: localStorage.getItem('username'),
        }
        payload.customer_data = userList;
        
        axios.post(ENVIRONMENT.ASSIGN_CUSTOMERS, payload).then(res => {
            console.log(res);
            // Hide loading message
            loadingMessage();
            // Show success modal
            setShowSuccessModal(true);
        }).catch(err => {
            console.log(err);
            // Hide loading message on error too
            loadingMessage();
        });
    }

    // Handle search functionality
    const handleSearch = (value) => {
        setSearchValue(value);
        
        if (value.length > 3) {
            const filtered = allUsers.filter(user => 
                (user.company_display_name && 
                 user.company_display_name.toLowerCase().includes(value.toLowerCase())) ||
                (user.email && 
                 user.email.toLowerCase().includes(value.toLowerCase()))
            );
            setFilteredUsers(filtered);
        } else {
            setFilteredUsers(allUsers);
        }
    };

    // Table columns configuration
    const columns = [
        {
            title: "Customer Username",
            dataIndex: "customer_username",
            key: "customer_username",
            render: (text) => text || "N/A"
        },
        {
            title: "Company Display Name",
            dataIndex: "company_display_name",
            key: "company_display_name",
            render: (text) => text || "N/A"
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            render: (text) => text || "N/A"
        },
        {
            title: "Subscription Package",
            dataIndex: "subscription_package",
            key: "subscription_package",
            render: (text) => text || "N/A"
        },
        {
            title: 'Actions',
            key: 'action_user_assign',
            dataIndex: 'action_user_assign',
            render: (text, record) => (
                <span>
                <a onClick={() => assignUser(record)}>Assign User to yourself</a>
                </span>
            ),
        },
    ];

    return (
        <>
            {
            isLoading ? <DottedLoader /> : 
            <div>
                <Row
                    className="justify-in-end"
                    style={{ marginTop: "10px", marginBottom: 20 }}
                >
                    <Col lg={10} xl={10}>
                        <Input
                            placeholder="Search by company name or email (min 4 characters)"
                            prefix={<SearchOutlined />}
                            onChange={(e) => handleSearch(e.target.value)}
                            className="manrope f-14 mat-search-bar"
                            value={searchValue}
                        />
                    </Col>
                </Row>
                <Divider />
                <Table
                    dataSource={filteredUsers}
                    columns={columns}
                    rowKey="customer_username"
                    scroll={{ x: true }}
                    pagination={{
                        pageSize: 10,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        showTotal: (total, range) => 
                            `${range[0]}-${range[1]} of ${total} items`
                    }}
                />
            </div>
            }
            
            <SuccessModal
                visible={showSuccessModal}
                heading="User Assigned Successfully!"
                text="User has been assigned to you. Please select the user and go to company users tab to change its settings."
                onCancel={() => setShowSuccessModal(false)}
                closable={true}
                footer={[
                    <div className="justify-in-center">
                        <Button style={{margin:"auto"}} className="modal-okay square font-14" htmlType="submit" onClick={() => {
                            window.location.reload();}}>
                            Okay
                        </Button>
                    </div>
                 ]}
            />
        </>
    )
};

export default AccountDetails;